export default {"src":"/planos/_next/static/media/arrow-down.d273e522.svg","height":11,"width":18,"blurWidth":0,"blurHeight":0};